<template>
  <v-app>
    <v-system-bar app :color="this.$store.getters.stdColorLight">
      <v-spacer></v-spacer>
      <v-icon :color="this.$store.getters.systemBarColor">mdi-account-outline</v-icon>
      <span v-html="getUserData(false)"></span>
    </v-system-bar>

    <v-app-bar app :color="this.$store.getters.stdColorLight">
      <v-app-bar-nav-icon v-if="this.$store.getters.isLoggedOn" @click="toggleDrawer()"></v-app-bar-nav-icon>

      <v-container fluid>
        <v-row align="center">
          <v-col xs="12" sm="6" md="4" lg="5">
            <router-view :name="this.$store.getters.routerViewToolbar"></router-view>
          </v-col>
          <v-spacer></v-spacer>
          <v-select
            color="primary"
            v-model="selectedSAPClient"
            v-if="this.$store.getters.isLoggedOn && this.authorityHelper.hasRoleAdmin()"
            :items="this.$store.getters.dataTargetList"
            item-title="title"
            item-value="sapClientId"
            :label="$t('message.chooseSAPClient')"
            @update:model-value="handleSAPClient()"
            dense
            hide-details="auto"
          ></v-select>
          <pl-shoppingcart></pl-shoppingcart>
          <v-menu
            v-model="value"
            :disabled="disabled"
            :absolute="absolute"
            :open-on-hover="openOnHover"
            :close-on-click="closeOnClick"
            :close-on-content-click="closeOnContentClick"
            :offset-x="offsetX"
            :offset-y="offsetY"
          >
            <template v-slot:activator="{ props }">
              <v-btn icon v-bind="props">
                <v-icon>mdi-dots-vertical</v-icon>
              </v-btn>
            </template>
            <v-list>
              <v-list-item :disabled="this.$store.getters.isLoggedOn" @click="handleLogon()">
                <v-list-item-title class="subtitle-2">{{ $t("message.anmelden") }}</v-list-item-title>
              </v-list-item>
              <v-list-item :disabled="!this.$store.getters.isLoggedOn" @click="handleLogon()">
                <v-list-item-title class="subtitle-2">{{ $t("message.abmelden") }}</v-list-item-title>
              </v-list-item>
              <v-divider :inset="inset"></v-divider>
              <v-list-item
                v-for="(lang, index) in langs"
                :key="index"
                @click="handleLanguage(lang.locale)"
              >
                <v-list-item-title class="subtitle-2">{{ lang.title }}</v-list-item-title>
              </v-list-item>
            </v-list>
          </v-menu>
          <pl-help></pl-help>
          <!--<pl-user-manual></pl-user-manual>-->
          <!--<pl-player-loader v-if="this.$store.getters.isLoggedOn"></pl-player-loader>-->
        </v-row>
      </v-container>
    </v-app-bar>

    <pl-navigation-drawer v-if="this.$store.getters.isLoggedOn"></pl-navigation-drawer>

    <v-main>
      <router-view :name="this.$store.getters.routerViewContent"></router-view>
    </v-main>
  </v-app>
</template>

<script>
import PlShoppingcart from "@/components/PLShoppingCart";
import PlHelp from "@/components/PLHelp";
import PlNavigationDrawer from "@/components/PLNavigationDrawer";
import WebService from "@/plugins/WebService";
import AuthorityHelper from "@/plugins/AuthorityHelper";
import LoggerHelper from "@/plugins/LoggerHelper";
import EntityHelper from "@/plugins/EntityHelper";
import UtilityHelper from "@/plugins/UtilityHelper";
import ShoppingCartHelper from "@/plugins/ShoppingCartHelper";
import movable from "@/components/movable";

export default {
  name: "App",
  
  components: {
    PlShoppingcart, PlNavigationDrawer, PlHelp, movable
  },

  data: () => ({
    webService: null,
    authorityHelper: null,
    entityHelper: null,
    utilityHelper: null,
    shoppingCartHelper: null,

    //languages, menu
    langs: [
      { locale: "de", title: "deutsch" },
      { locale: "fr", title: "französisch" },
      { locale: "en", title: "englisch" }
    ],

    disabled: false,
    absolute: false,
    openOnHover: false,
    value: false,
    closeOnClick: true,
    closeOnContentClick: true,
    offsetX: false,
    offsetY: true,
    inset: false,
  }),

  computed: {
    drawer: {
      get() {
        return this.$store.state.navigationDrawer.drawer
      },

      set(value) {
        this.$store.dispatch('setNavigationDrawer', value)
      }
    },

    selectedSAPClient: {
      get() {
        return this.$store.getters.selectedSAPClient
      },

      set(value) {
        this.$store.dispatch("setSelectedSAPClient", value);
        this.webService
          .getUser(this.$store.getters.getUser, this.$store.getters.user.username, value)
          .then(response => {
            LoggerHelper.logEvent(LoggerHelper.levelInfo, this.$t("logging.userData", { logvar1: this.$store.getters.user.username }), response.data);
            this.$store.dispatch("setUser", [response.data]);
          }
        );        
      }
    }    
  },

  created() {
    LoggerHelper.initLogger(this);

    this.webService=new WebService(this);
    this.authorityHelper=new AuthorityHelper(this);
    this.entityHelper = new EntityHelper(this);
    this.utilityHelper = new UtilityHelper(this);
    this.shoppingCartHelper = new ShoppingCartHelper(this);
  },

  mounted() {
    this.$store.dispatch("setSelectedLanguage", this.$root.$i18n.locale);
  },

  methods: {
    // toggle the drawer state to open or close it
    toggleDrawer() {
      this.drawer = !this.drawer
    },

    getUserData(colorMode)
    {
      if (colorMode)
      {
        if ((this.$store.getters.isLoggedOn) && (this.$store.getters.user!=null))
          return "<span style='color:"+this.$store.getters.systemBarColor+"'>"+this.$store.getters.user.kdnnr+" "+this.$store.getters.user.firma+","+this.$store.getters.user.username+"</span>";
        else
          return "<span style='color:"+this.$store.getters.systemBarColor+"'>"+this.$store.getters.username+"</span>";
      }
      else
      {
        if ((this.$store.getters.isLoggedOn) && (this.$store.getters.user!=null))
          return this.$store.getters.user.kdnnr+" "+this.$store.getters.user.firma+","+this.$store.getters.user.username;
        else
          return this.$store.getters.username;
      }
    },

    handleLanguage: function(aLocale) {
      this.$root.$i18n.locale = aLocale;
      //force watch to be executed
      this.$store.dispatch("setSelectedLanguage", aLocale);
      this.resetData();
    },

    handleSAPClient: function() {
      this.resetData();
      this.utilityHelper.initPLParameters();
      this.utilityHelper.initPLItems();
    },

    handleLogon: function() {
      LoggerHelper.logEvent(LoggerHelper.levelInfo, "init logon", "");

      this.$store.dispatch("setUser", null);
      this.$store.dispatch("setActualUser", { username: "", password: "" });

      this.resetData();

      this.$store.dispatch('setSystemBarColor', this.$store.getters.colorSystemBarOff);
      this.$store.dispatch("setLoggedOn", false);
    },

    resetData()
    {
      this.$store.dispatch("setArtikel", "");
      this.$store.dispatch("setPLComboData", {});
      this.utilityHelper.initPLParameters();
      this.$store.dispatch("setPLList", []);
      this.$store.dispatch("setCartCounter", 0);
      this.shoppingCartHelper.clear();
      this.entityHelper.clearMasterDataState();
      this.entityHelper.setMasterDataState("showPL", true);
      var plConfig = this.$store.getters.plConfig;
      plConfig.plTitle = this.$t("message.plliste");
      plConfig.plIcon = 'md:analytics';
      this.$store.dispatch("setPLConfig", plConfig);
    }
  }

};
</script>
